export const reportError = (error: any, info: any) => {
  console.log(error);
  console.log(info);
};
